<template>
    <section>
        <div class="row">
            <template v-if="show('syear')">
                <div class="col">
                    <form-input v-model="query.syear" id="syear" :label="$t('components.query.syear')" type="number"></form-input>
                </div>
            </template>
            <template v-if="show('semester')">
                <div class="col">
                    <form-select v-model="query.semester" id="semester" :label="$t('components.query.semester')">
                        <div v-if="!show('semester-nonall')" is="option" value="">{{$t('components.query.semester_full')}}</div>
                        <div is="option" value="u">{{$t('components.query.semester_first')}}</div>
                        <div is="option" value="d">{{$t('components.query.semester_second')}}</div>
                    </form-select>
                </div>
            </template>
            <template v-if="show('date')">
                <div class="col">
                    <form-date-input v-model="query.start" id="start" label="日期(起)"></form-date-input>
                </div>
                <div class="col">
                    <form-date-input v-model="query.end" id="end" label="日期(迄)"></form-date-input>
                </div>
            </template>
        </div>
        <div class="row">
            <template v-if="show('ssystem')">
                <div class="col-md col-sm-12">
                    <form-select v-model="query.ssystem" id="ssystem" label="學制" @change="search">
                        <div is="option" value="">全部</div>
                        <div is="option" v-for="o in ssystem" :key="o.key" :value="o.key">{{o.value}}</div>
                    </form-select>
                </div>
            </template>
            <template v-if="show('college')">
                <div class="col-md col-sm-12">
                    <form-select v-model="query.college" id="college" label="學院" @change="search">
                        <div is="option" value="">全部</div>
                        <div is="option" v-for="o in college" :key="o.key" :value="o.key">{{o.value}}</div>
                    </form-select>
                </div>
            </template>
            <template v-if="show('department')">
                <div class="col-md col-sm-12">
                    <form-select v-model="query.department" id="department" label="科系" @change="search">
                        <div is="option" value="">全部</div>
                        <div is="option" v-for="o in department" :key="o.key" :value="o.key">{{o.value}}</div>
                    </form-select>
                </div>
            </template>
            <template v-if="show('sclass')">
                <div class="col-md col-sm-12">
                    <form-select v-model="query.class" id="class" label="班級">
                        <div is="option" value="">全部</div>
                        <div is="option" v-for="o in sclass" :key="o.key" :value="o.key">{{o.value}}</div>
                    </form-select>
                </div>
            </template>
        </div>
        <div class="row">
            <slot></slot>
            <template v-if="show('keyword')">
                <div class="col-md col-sm-12">
                    <form-input v-model="query.keyword" id="keyword" :label="$t('components.query.keyword')" type="text" :placeholder="$attrs['keyword']"></form-input>
                </div>
            </template>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'query',
        props: ['value'],
        data: function () {
            return {
                query: { ...this.value, syear: '', semester: '', start: '', end: '', ssystem: '', college: '', department: '', class: '', keyword: '' },
                ssystem: [], college: [], department: [], sclass: []
            }
        },
        created: function () {
            this.$http({ method: 'get', url: 'api//Parameter/Class', })
                .then(res => {
                    this.ssystem = res.data.SSystem;
                    this.college = res.data.College;
                    this.department = res.data.Department;
                    this.sclass = res.data.Class;
                });
            this.$emit('input', this.query);
        },
        methods: {
            show: function (key) {
                if (key === "keyword")
                    return this.$attrs[key].length > 0 || this.$attrs[key] === true;
                return this.$attrs[key] === "" || this.$attrs[key] === true;
            },
            search: function () {
                this.$http({ method: 'get', url: 'api//Parameter/Class', params: { SSystemID: this.query.ssystem, CollegeID: this.query.college, DepartmentID: this.query.department, ClassID: this.query.class } })
                    .then(res => {
                        this.ssystem = res.data.SSystem;
                        this.college = res.data.College;
                        if (!res.data.isCollege) { this.query.college = null; }
                        this.department = res.data.Department;
                        if (!res.data.isDepartment) { this.query.department = null; }
                        this.sclass = res.data.Class;
                        if (!res.data.isClass) { this.query.class = null; }
                    });
                this.$emit('input', this.query);
            }
        }
    };
</script>

<style>
</style>